import { useState } from 'react';
import classes from './TermsOfServices.module.scss';
import Modal from '../UI/Modal';

import vectore from '../../assets/svgs/Vector.svg';

export default function TermsOfServices({ text, t, language }) {
  const [isShowen, setIsShowen] = useState(false);
  const [isExtend, setIsExtend] = useState(false);

  const toggleModalSize = () => {
    setIsExtend((prev) => !prev);
  };

  const toggleModalHandler = () => {
    setIsShowen((prev) => !prev);
  };

  return (
    <>
      {isShowen && (
        <Modal onClose={toggleModalHandler}>
          <div
            className={`${classes.text} ${classes[language]} ${
              isExtend ? classes.extend : ''
            }`}
          >
            {t('Terms of Services Text')}
            <span className={classes['arrow-container']}>
              <img
                src={vectore}
                alt=""
                className={`${classes.arrow} ${isExtend ? classes.extend : ''}`}
                onClick={toggleModalSize}
              />
            </span>
          </div>
        </Modal>
      )}
      <span className={classes.terms} onClick={toggleModalHandler}>
        {text}
      </span>
    </>
  );
}
